/** Fixed upper bound of the heatmap color scale: 3 in expressed as mm */
export const HEATMAP_MAX_MM = 3 * 25.4 // ≈ 76.2

/**
 * Pre-computed hex color stops used by both the map layer cells and the
 * legend gradient bar. Hue runs 0°→240° at saturation 80 %, lightness 25 %.
 *   hsl(0,   80%, 25%) = #730d0d  dark red   (0 in)
 *   hsl(60,  80%, 25%) = #73730d  dark yellow (0.75 in)
 *   hsl(120, 80%, 25%) = #0d730d  dark green  (1.5 in)
 *   hsl(180, 80%, 25%) = #0d7373  dark teal   (2.25 in)
 *   hsl(240, 80%, 25%) = #0d0d73  dark blue   (3 in)
 */
export const GRADIENT_HEX_COLORS = [
  "#730d0d",
  "#73730d",
  "#0d730d",
  "#0d7373",
  "#0d0d73",
] as const

function hslToRgb(h: number, s: number, l: number): [number, number, number] {
  s /= 100
  l /= 100
  const k = (n: number) => (n + h / 30) % 12
  const a = s * Math.min(l, 1 - l)
  const f = (n: number) =>
    l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))
  return [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)]
}

/**
 * Returns the RGBA components for a heatmap cell.
 *   0 mm  → dark red,  ~15 % opacity
 *   76 mm → dark blue, ~82 % opacity
 */
export function heatmapCellColor(accumulatedMm: number): {
  r: number
  g: number
  b: number
  a: number
} {
  const t = Math.max(0, Math.min(1, accumulatedMm / HEATMAP_MAX_MM))
  const [r, g, b] = hslToRgb(t * 240, 80, 25)
  const a = 0.15 + t * 0.67
  return { r, g, b, a }
}
